import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ItemGeneralListado } from '../../helpers/components/itemClasses/itemListadoGeneral.class';
import { Observable } from 'rxjs/Observable';
import { OutputService } from '../../infrastructure/services/output.service';
import { TemplateListadoItem } from 'app/infrastructure/model/classes/templateListadoItem.class';

@Component({
    selector: 'sx-list-output',
    templateUrl: './list.output.component.html',
})
export class ListOutputComponent implements OnInit {
    codSistema: string;
    outputs: Observable<TemplateListadoItem[]>;

    constructor(
        private aRoute: ActivatedRoute,
        private _router: Router,
        private outputService: OutputService,
    ) { }

    ngOnInit() {
        this.aRoute.params.subscribe((params: Params) => {
            this.codSistema = params['codsistema'];
            this.outputs = this.outputService.getList(this.codSistema);
        });
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/outputs/list.output.component.ts